import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { type Dispatch, type SetStateAction, useCallback } from 'react';
import type { TransferListBaseItem, TransferListItemsMap } from '../types';

type UseTransferListTransferActionsArgs<TItem extends TransferListBaseItem> = {
  leftSelectedItems: TransferListItemsMap<TItem>;
  rightSelectedItems: TransferListItemsMap<TItem>;
  setLeftItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
  setLeftSelectedItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
  setRightItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
  setRightSelectedItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
};

export const useTransferListTransferActions = <TItem extends TransferListBaseItem>({
  leftSelectedItems,
  rightSelectedItems,
  setLeftItems,
  setLeftSelectedItems,
  setRightItems,
  setRightSelectedItems,
}: UseTransferListTransferActionsArgs<TItem>) => {
  const handleLeftToRightTransfer = useCallback(() => {
    setLeftItems(prev => omit(prev, Object.keys(leftSelectedItems)));
    setLeftSelectedItems({});
    setRightItems(prev => merge({ ...prev }, leftSelectedItems));
  }, [leftSelectedItems, setLeftItems, setLeftSelectedItems, setRightItems]);

  const handleRightToLeftTransfer = useCallback(() => {
    setLeftItems(prev => merge({ ...prev }, rightSelectedItems));
    setRightSelectedItems({});
    setRightItems(prev => omit(prev, Object.keys(rightSelectedItems)));
  }, [rightSelectedItems, setLeftItems, setRightItems, setRightSelectedItems]);

  return {
    handleLeftToRightTransfer,
    handleRightToLeftTransfer,
  };
};
